/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Sparkles } from "lucide-react";

/**
 * Single, sticky, gold "Take the Dosha Test" bubble CTA.
 * - Appears on every page EXCEPT the Dosha pages themselves
 * - Auto-collapses on mobile after a moment to avoid covering content
 * - Sits above the footer/bottom safe area
 */
export default function FloatingDoshaCTA() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(true);
  const [collapsed, setCollapsed] = useState(false);

  // Hide on Dosha pages, auth chrome, checkout, and the homepage itself
  // (Homepage already has a prominent Take the Dosha Test CTA in the hero).
  useEffect(() => {
    const hideOnExact = ["/", "/login", "/signup"];
    const hideOnPrefix = ["/dosha", "/auth", "/reset-password", "/shop/success", "/shop/checkout", "/checkout"];
    setVisible(
      !hideOnExact.includes(pathname) &&
      !hideOnPrefix.some((p) => pathname === p || pathname.startsWith(p + "/"))
    );
  }, [pathname]);

  // Auto-collapse on mobile after 6s
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.innerWidth < 768) {
      const t = setTimeout(() => setCollapsed(true), 6000);
      return () => clearTimeout(t);
    }
  }, [pathname]);

  if (!visible) return null;

  return (
    <Link
      to="/dosha"
      data-testid="floating-dosha-cta"
      aria-label={t("dosha.cta_floating", "Take the Dosha Test")}
      onClick={() => setCollapsed(false)}
      className={`fixed z-50 bottom-36 end-5 group ${
        collapsed ? "w-14 h-14" : "px-5 py-3.5"
      } rounded-full bg-gradient-to-br from-[#E8D199] via-[#D4AF37] to-[#7A5F2A]
        text-black shadow-[0_10px_40px_-10px_rgba(212,175,55,0.65)] hover:shadow-[0_14px_50px_-8px_rgba(212,175,55,0.85)]
        transition-all duration-300 flex items-center gap-2.5 font-medium text-sm
        hover:-translate-y-0.5 active:translate-y-0`}
    >
      <Sparkles className={`flex-shrink-0 ${collapsed ? "w-6 h-6 mx-auto" : "w-4 h-4"}`} />
      {!collapsed && (
        <span className="whitespace-nowrap tracking-tight">
          {t("dosha.cta_floating", "Take the Dosha Test")}
        </span>
      )}
      {/* Subtle pulse halo */}
      <span className="absolute inset-0 rounded-full ring-2 ring-[#D4AF37]/40 animate-ping pointer-events-none opacity-70" aria-hidden="true" />
    </Link>
  );
}
